"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "guardia-lombardi": {
    "97a2490c": [{
      "hkey": "77803efc",
      "slug": "guardia-lombardi",
      "name": "Guardia Lombardi",
      "primary": true,
      "skipSearch": false
    }],
    "carmasciano": [{
      "hkey": "77803efc",
      "slug": "guardia-lombardi",
      "name": "Guardia Lombardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7aeb1186": [{
      "hkey": "77803efc",
      "slug": "guardia-lombardi",
      "name": "Guardia Lombardi",
      "primary": true,
      "skipSearch": false
    }],
    "frassino": [{
      "hkey": "77803efc",
      "slug": "guardia-lombardi",
      "name": "Guardia Lombardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6ec3b61b": [{
      "hkey": "77803efc",
      "slug": "guardia-lombardi",
      "name": "Guardia Lombardi",
      "primary": true,
      "skipSearch": false
    }],
    "piani": [{
      "hkey": "77803efc",
      "slug": "guardia-lombardi",
      "name": "Guardia Lombardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f044b8e": [{
      "hkey": "77803efc",
      "slug": "guardia-lombardi",
      "name": "Guardia Lombardi",
      "primary": true,
      "skipSearch": false
    }],
    "sasso": [{
      "hkey": "77803efc",
      "slug": "guardia-lombardi",
      "name": "Guardia Lombardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;